import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconHub12 from './IconHub12';
import IconHub16 from './IconHub16';
import IconHub20 from './IconHub20';
import IconHub24 from './IconHub24';
import IconHub32 from './IconHub32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconHub = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconHub12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconHub16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconHub20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconHub24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconHub32 {...props} />}
        </span>
    );
};
IconHub.displayName = 'FondueIconHub';

export default memo(IconHub);
